// Catalog.ID Client — BIT and units
// ============================================================================
// The ledger counts in units, 1 BIT = 10⁸ units, and writes them as decimal
// strings (apps/bitcash/docs/plans/bitcash-v2.md §4.21.1): a value that can pass 2⁵³ never goes
// through a JavaScript number. These two helpers are the only conversions.

const UNITS_PER_BIT = 100_000_000n;

/** Whole BIT (as configured: the D27 token caps, a gift) to a units string. */
export function bitToUnits(bit: number): string {
    if (!Number.isSafeInteger(bit) || bit < 0) throw new Error(`a BIT amount is a whole number; got ${bit}`);
    return (BigInt(bit) * UNITS_PER_BIT).toString();
}

/** A units string to BIT for display: `"1050000000"` → `"10.5"`, `"0"` → `"0"`. */
export function unitsToBit(units: string): string {
    if (!/^-?(0|[1-9][0-9]*)$/.test(units)) return units;
    const negative = units.startsWith('-');
    const value = BigInt(negative ? units.slice(1) : units);
    const whole = value / UNITS_PER_BIT;
    const fraction = (value % UNITS_PER_BIT).toString().padStart(8, '0').replace(/0+$/, '');
    return `${negative ? '-' : ''}${whole.toString()}${fraction ? `.${fraction}` : ''}`;
}

/** A units string to whole BIT (rounded down) for a printed figure; null when it is not a units string. */
export function unitsToWholeBit(units: string | undefined): number | null {
    if (units === undefined || !/^(0|[1-9][0-9]*)$/.test(units)) return null;
    return Number(BigInt(units) / UNITS_PER_BIT);
}
